import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=f50e95bc&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=ts"
export * from "./VideoModal.vue?vue&type=script&lang=ts"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=f50e95bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50e95bc",
  null
  
)

export default component.exports